import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';

import usePushDataLayerEvent from '../../../utils/google-analytics.util';
import { errorData } from '../../../utils/debug.util';
import { handleToggleChat } from '../../../store/slices/generalSlice';
import { RootState } from '../../../store/rootReducer';
import { ContentLayout } from '../../../global-styles/layout';
import { theme } from '../../../global-styles/colors';
import { PHONE_CONTACT_NUMBER } from '../../../constants';
import { BodySmallText, Heading4Text } from '../../../components/typography/typography';
import { ImbeeChatVariables } from '../../../components/imbee-chat/imbee-chat-utils';
import ImbeeChat from '../../../components/imbee-chat/ImbeeChat';
import Header from '../../../components/header/Header';
import CardInfo from '../../../components/card-info/CardInfo';
import AlxButton from '../../../components/alx-components/button';
import { requestAnInsuranceCall } from '../../../api/assistance/assistance';
import { ContactStyle } from './contact-style';

const Contact = () => {
  const { t } = useTranslation(['common', 'contact']);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pushDataLayerEvent } = usePushDataLayerEvent();

  const requestAcall = useMutation({
    mutationFn: (insurance?: string) => requestAnInsuranceCall(insurance),
  });
  const insurance = useSelector((state: RootState) => state.general.provider);

  const chatVariables: ImbeeChatVariables = [['pantalla', 'contactoMenu']];

  useEffect(() => {
    // contacto
    pushDataLayerEvent('screen_view', null, 'contacto');
  }, [pushDataLayerEvent]);

  return (
    <>
      <Header />
      <ContentLayout className="with-navbar">
        <ContactStyle>
          <Heading4Text className="m-12px" weight={600}>
            {t('contact:title')}
          </Heading4Text>
          <BodySmallText color={theme.type.secondary} className="m-24px">
            {t('contact:subtitle')}
          </BodySmallText>
          <div className="contact-info m-40px">
            <CardInfo title={t('contact:assistance')} data={[{ title: '', description: [PHONE_CONTACT_NUMBER] }]} />
          </div>
          <BodySmallText color={theme.type.secondary} className="m-24px">
            {t('contact:text')}
          </BodySmallText>
          <div className="buttons-wrapper">
            <div className="buttons-wrapper__item">
              <AlxButton
                onClick={() => {
                  requestAcall.mutate(insurance, {
                    onSuccess: () => {
                      pushDataLayerEvent('contacto', { metodo_contacto: 'phone' }, 'contacto');
                      navigate('/callme-back');
                    },
                    onError: (e) => {
                      errorData(e);
                    },
                  });
                }}
                data-cy="login-submit"
              >
                {t('contact:call')}
              </AlxButton>
            </div>
            <div className="buttons-wrapper__item">
              <AlxButton
                className={'secondary'}
                onClick={() => {
                  dispatch(handleToggleChat());
                  pushDataLayerEvent('contacto', { metodo_contacto: 'chat' }, 'contacto');
                }}
              >
                {t('contact:chat')}
              </AlxButton>
            </div>
          </div>
        </ContactStyle>
      </ContentLayout>
      <ImbeeChat chatVariables={chatVariables} />
    </>
  );
};

export default Contact;
